/* globals _ */

const { where } = _;

import Collection from '../framework/collections/base';
import CheckboxSet from '../framework/collection-views/checkbox-set';

export default function( $, app ) {
	var $body = $( 'body' );

	var {
		foundVenues,
		model: session,
		views: {
			venuesList,
			categoriesList,
		},
		markers: {
			stopMarkers,
		},
	} = app;

	var { collection: categories } = categoriesList;

	// =========================
	// ! Setup View
	// =========================

	function disableIfNoVenues() {
		var noVenues = this.model.get( 'count' ) === 0;

		this.setDisabled( noVenues );
	}

	var filter = new CheckboxSet( {
		el: '#filter',
		collection: categories,
		childOptions: {
			template: '#tpl_filter_item',
			listeners: { 'model change:count': disableIfNoVenues },
			on: { render: disableIfNoVenues },
		},
	} );

	filter.render();

	// =========================
	// ! Category Filtering
	// =========================

	foundVenues.addPredicate( 'inCategory', model => {
		return filter.checked.get( model.get( 'category' ) );
	}, () => {
		// Only filter if some but not all enabled options are checked
		return filter.checked.length > 0 && filter.checked.length < where( filter.children, { isDisabled: false } ).length;
	} );

	var lastFilter = [];

	filter.$el
	.on( 'submit showing', () => {
		lastFilter = filter.checked.pluck( 'id' );
	} )
	.on( 'reset', () => {
		filter.reset( lastFilter );
	} )
	.on( 'submit', () => {
		foundVenues.filterSubset();
	} );

	app.on( 'filter:category', category => {
		if ( category ) {
			category = categories.get( category );
			filter.reset( lastFilter = [ category.id ] );
		} else {
			filter.reset( lastFilter = [] );
		}
		foundVenues.filterSubset();
	} );

	categoriesList.on( 'child:select', card => {
		venuesList.$el.one( 'showing', () => {
			app.trigger( 'filter:category', card.model );
		} );
	} );

	// =========================
	// ! Events-Only Handling
	// =========================

	var $eventsOnly = $( '.events_only' );

	foundVenues.addPredicate( 'eventsOnly', model => {
		return model.get( 'isEvent' );
	}, () => {
		// Only filter if eventsOnly is checked
		return $( '.events_only:checked' ).length > 0;
	} );

	$eventsOnly.change( function() {
		$eventsOnly.each( ( i, elm ) => {
			elm.checked = this.checked;
		} );
		$body.toggleClass( 'events-only', this.checked );
		app.trigger( 'filter:events_only', this.checked );
		foundVenues.filterSubset();
	} );

	// =========================
	// ! Radius Handling
	// =========================

	var RADIUS_MIN = 5,
		RADIUS_MAX = 50,
		RADIUS_STEP = 5;

	var $radiusSlider = $( '#filter_radius' ),
		$radiusInput = $radiusSlider.find( 'input' ),
		$radiusRange = $radiusSlider.find( '.slider-range' ),
		$radiusThumb = $radiusSlider.find( '.slider-thumb' );

	$radiusInput.val( session.get( 'area' ) )
	.on( 'input', function() {
		var value = parseInt( this.value || '0', 10 );

		value = Math.min( RADIUS_MAX, Math.max( RADIUS_MIN, value ) );

		$radiusThumb.css( 'left', ( ( value - RADIUS_MIN ) / ( RADIUS_MAX - RADIUS_MIN ) ) * 100 + '%' );
		$radiusThumb.text( value );
	} ).trigger( 'input' );

	$radiusSlider.on( 'mousedown touchstart', e => {
		var moveEvent = e.type === 'touchstart' ? 'touchmove' : 'mousemove',
			endEvent = e.type === 'touchstart' ? 'touchend' : 'mouseup';

		function drag( move ) {
			move.preventDefault();
			move = move.originalEvent;

			if ( move.touches ) {
				move = move.touches[0];
			}

			var rangeWidth = $radiusRange.width(),
				rangeBox = $radiusRange[0].getBoundingClientRect();

			var amount = ( move.clientX - rangeBox.left ) / rangeWidth;
				amount = Math.min( 1, Math.max( 0, amount ) );

			var value = Math.round( amount * ( ( RADIUS_MAX - RADIUS_MIN ) / RADIUS_STEP ) ) * RADIUS_STEP + RADIUS_MIN;

			$radiusThumb.css( 'left', amount * 100 + '%' );
			$radiusThumb.text( value );
			$radiusInput.val( value );
		}

		$radiusSlider.on( moveEvent, drag );
		$radiusSlider.on( endEvent, () => {
			$radiusSlider.off( moveEvent, drag );
		} );
	} );

	var lastRadius = session.get( 'area' );
	session.on( 'change:area', () => {
		lastRadius = session.get( 'area' );
	} );

	filter.$el
	.on( 'submit', () => {
		session.set( 'area', $radiusInput.val() );
	} )
	.on( 'reset', () => {
		$radiusInput.val( lastRadius ).trigger( 'input' );
	} );

	// =========================
	// ! Sort Handling
	// =========================

	var lastSort = 'distance:asc';

	var $sortOptions = $( 'input[name="sort"]' );
	$sortOptions.filter( `[value="${lastSort}"]` ).attr( 'checked', true );

	filter.$el
	.on( 'submit', () => {
		var sort = $sortOptions.filter( ':checked' ).val();
		venuesList.childSort = sort.split( ':' );
		venuesList.sortChildren();
	} )
	.on( 'reset', () => {
		$sortOptions.attr( 'checked', false ).filter( `[value="${lastSort}"]` ).attr( 'checked', true );
	} );

	foundVenues.addPredicate( 'sortable', model => {
		return model.get( venuesList.childSort[0] ) !== '';
	}, () => {
		// Only filter if there is a sort rule on the list
		return Boolean( venuesList.childSort );
	} );

	// =========================
	// ! Search Filtering
	// =========================

	var $search = $( '#search' ),
		$searchInput = $( '#venue_search' );

	$search.submit( e => {
		e.preventDefault();
		document.getElementById( 'search' ).blur();
		$search.hideView();

		var query = $searchInput.val();

		if ( query.length < 3 ) {
			venuesList.callEach( 'show' );
			stopMarkers.callEach( 'show' );
			return;
		}

		venuesList.each( child => {
			if ( child.model.matchSearch( query ) > 0 ) {
				child.show();
			} else {
				child.hide();
			}
		} );

		stopMarkers.each( child => {
			if ( child.model.matchSearch( query ) > 0 ) {
				child.show();
			} else {
				child.hide();
			}
		} );
	} );

	// =========================
	// ! Search Suggestions
	// =========================

	var $suggestions = $( '#suggestions' );

	var tags = new Collection( [], { comparator: 'count' } );

	$search.on( 'showing', () => {
		tags.reset();
		$suggestions.empty();

		venuesList.collection.each( venue => {
			venue.get( 'keywords' ).split( '#' ).forEach( tag => {
				if ( tag ) {
					tag = tag.trim();
					tag = ( tags.get( tag ) || tags.add( { id: tag, count: 0 } ) );
					tag.set( 'count', tag.get( 'count' ) + 1 );
				}
			} );
		} );

		tags.sort();

		tags.slice( 0, 8 ).forEach( tag => {
			var i = Math.floor( Math.random() * 8 );
			$suggestions.append( `<input type="button" class="tag _${i}" value="${tag.id}" />` );
		} );
	} );

	$suggestions.on( 'click', '.tag', function() {
		$searchInput.val( ( $searchInput.val() + ' ' + this.value ).trim() );
	} );

	// =========================
	// ! Filter Basics
	// =========================

	filter.$el
	.on( 'submit', e => {
		e.preventDefault();
		filter.$el.hideView();
		foundVenues.filterSubset();
	} )
	.on( 'reset', e => e.preventDefault() );

	$( '#filter, #search' ).on( 'submit reset', () => {
		$body.addClass( 'navigating-back' );
	} );

	// =========================
	// ! Expose to app object
	// =========================

	app.views.filter = filter;
}
